Vue.component('baked-cake-counter', {
    created() {
        this.number = +$('#cakeNumber').text().replace(/\s/g, '');
        this.startTimer();
    },
    data() {
        return {
            number: null
        }
    },
    methods: {
        startTimer() {
            setInterval(() => {
                this.getCakeNumber();
            }, 10000)
        },
        getCakeNumber() {
            axios.get('/site/get-cake-number').then(response => {
                let cakeNumber = +response.data.cakeNumber.replace(/\s/g, '')
                let step = cakeNumber - this.number;

                if (response.data.hasOwnProperty('cakeNumber')) {
                    if (cakeNumber - this.number < 100 && cakeNumber !== this.number) {
                        const interval = setInterval(() => {
                            if (++this.number >= cakeNumber) {
                                clearInterval(interval);
                            }
                            $('#cakeNumber').text(this.number.toLocaleString());
                        }, 2000 / step)
                    } else {
                        this.number = cakeNumber;
                        $('#cakeNumber').text(this.number.toLocaleString());
                    }
                    $('#cakes').text(response.data.cakes);
                }
            });
        }
    }
})
